import AddLinkIcon from '@mui/icons-material/AddLink';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CurrencyLiraIcon from '@mui/icons-material/CurrencyLira';
import DashboardIcon from '@mui/icons-material/Dashboard';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { LinearProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import AccountsPage from '../Pages/Account/AccountsPage';
import AccountNew from "../Pages/AccountNew";
import GatewayPaymentPage from "../Pages/Gateway/GatewayPaymentPage";
import Home from "../Pages/Home";
import Landing from "../Pages/Landing";
import CreatePaymentPage from "../Pages/Payment/CreatePaymentPage";
import PaymentPage from "../Pages/Payment/PaymentPage";
import PaymentSessionsList from "../Pages/Payment/PaymentSessionsListPage";
import PaymentsPage from "../Pages/Payment/PaymentsPage";
import PaymentNew from "../Pages/PaymentNew";
import Plugins from "../Pages/Plugins";
import RecipientNew from "../Pages/RecipientNew";
import LoginForm from "../Pages/registration/LoginForm";
import RegisterForm from "../Pages/registration/RegisterForm";
import TelegramNotificationConfig from '../Pages/Settings/Notification/Telegram';
import Settings from "../Pages/Settings/Settings";
import TokenNew from '../Pages/TokenNew';
import Profile from '../Pages/User/Profile';

var routes = [
    { name: "profile", href: "/profile", private: true, component: <Profile />, showOnSidebar: false },
    { name: "landing", href: "/", private: false, component: <Landing />, showOnSidebar: false },
    { name: "plugins", href: "/plugins", private: false, component: <Plugins />, showOnSidebar: false },
    { name: "menuItem.home", href: "/home", private: true, component: <Home />, showOnSidebar: true, icon: <DashboardIcon /> },
    { name: "menuItem.newRecipient", href: "/recipient/new", private: true, component: <RecipientNew />, showOnSidebar: false },
    { name: "menuItem.Accounts", href: "/accounts", private: true, component: <AccountsPage />, showOnSidebar: true, icon: <CreditCardIcon /> },
    { name: "menuItem.newAccount", href: "/account/:id?", private: true, component: <AccountNew />, showOnSidebar: false },

    { name: "menuItem.Payments", href: "/payments", private: true, component: <PaymentsPage />, showOnSidebar: true, icon: <AddLinkIcon /> },
    { name: "menuItem.payment", href: "/payment/:id?", private: true, component: <PaymentNew />, showOnSidebar: false },

    // { name: t("menuItem.newPayment"), href: "/payment/new", private: true, component: <PaymentNew />, showOnSidebar: true, icon: <AddLinkIcon /> },
    { name: "menuItem.payment", href: "/payment/pay/:sessionId", private: false, component: <PaymentPage />, showOnSidebar: false },
    { name: "menuItem.payment", href: "/gw/pay/:sessionId", private: false, component: <GatewayPaymentPage />, showOnSidebar: false },
    { name: "menuItem.create", href: "/payment/create/:id", private: false, component: <CreatePaymentPage />, showOnSidebar: false },
    { name: "menuItem.tokenNew", href: "/token/new", private: true, component: <TokenNew />, showOnSidebar: false, icon: <CurrencyLiraIcon /> },
    { name: "loginRegister", href: "/register", private: false, component: <RegisterForm />, showOnSidebar: false },
    { name: "loginLogin", href: "/login", private: false, component: <LoginForm />, showOnSidebar: false },
    { name: "menuItem.paymentSessionList", href: "/sessions", private: true, component: <PaymentSessionsList />, showOnSidebar: true, icon: <ListAltIcon /> },
    { name: "menuItem.settings", href: "/settings", private: true, component: <Settings />, showOnSidebar: true , icon:<DisplaySettingsIcon/> },
    { name: "menuItem.Telegram", href: "/notification/configure/Telegram", private: true, component: <TelegramNotificationConfig />, showOnSidebar: false , icon:<DisplaySettingsIcon/> },
]
export default routes;

export function useRoutes() {
    const loggedin = useSelector((state) => !!state.session.user);
    


    const [privateRoutes, setPrivateRoutes] = useState([]);

    useEffect(() => {
        if (loggedin) {
            setPrivateRoutes(routes.filter(r => r.private))
        } else {
            setPrivateRoutes([]);
        }
    }, [loggedin])
    return (
        <>



            {
                !loggedin && privateRoutes.length > 0 ? <LinearProgress /> : <Switch>
                    {
                        privateRoutes.map((r, i) => {
                            return <Route key={r.name} exact path={r.href}>
                                {r.component}
                            </Route>
                        })
                    }


                </Switch>
            }
            <Switch>
                {
                    routes.filter(r => !r.private).map((r, i) => {
                        return <Route key={r.name} exact path={r.href}>
                            {r.component}
                        </Route>
                    })
                }
            </Switch>
        </>

    )
}
